import React, { useState, useEffect } from "react";
import "./PopupMenu.css";
import more from "../icons/more_horiz-24px.svg";
import AddBookmarkMutation from "../mutations/AddBookmarkMutation";
// import SvgBookmarkIcon from "../icons/iconComponents/BookmarkIcon";
import { commitLocalUpdate } from "react-relay";
import environment from "../Environment";
import { NoteModal, ShareModal } from "./Modal";
import BookmarkContainer from "./BookmarkContainer";
import { useNavigate } from "react-router-dom";
import SvgWebIcon from "../icons/iconComponents/WebIcon";
import { useTheme } from "../contexts/ThemeContext";
import SvgLinkIcon from "../icons/iconComponents/LinkIcon";
import SvgShareIcon from "../icons/iconComponents/ShareIcon";
import SvgNoteIcon from "../icons/iconComponents/Note";
import SvgBookmarkIcon from "../icons/iconComponents/Bookmark";
import { useMediaQuery } from "react-responsive";
import { updateLocalSetting } from "../Environment";

import FullSpanNoteModal from "../components/FullSpanNoteModal";
import FullSpanShareModal from "../components/FullSpanShareModal";

function PopupMenu(props) {
    const [isActivated, setIsActivated] = useState(false);
    const [isBookmarked, setIsBookmarked] = useState(false);
    const [isNoteModalActive, setIsNoteModalActive] = useState(false);
    const [isShareModalActive, setIsShareModalActive] = useState(false);
    const navigate = useNavigate();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    const user = props.user;
    const settings = props.settings;
    const { isFullSpanNoteModalActivated, isFullSpanShareModalActivated } =
        props.settings;
    const { is_premium, payment_status } = props.user;

    const postId = props.postId;

    let postIdInt = atob(postId).split(":").pop();

    const itemList = [
        "Bookmark",
        "Share",
        "Hide",
        "Copy Link",
        "Add Note",
        "View Similar",
    ];

    function setSeletedPost(id) {
        commitLocalUpdate(environment, (store) => {
            const record = store.getRoot().getLinkedRecord("settings");
            record.setValue(id, "selectedPostId");
        });
    }

    function onArticleMenuClick(e) {
        e.preventDefault();
        setIsActivated(!isActivated);
        setSeletedPost(props.postId);
        console.log(props.postId);
    }

    function onMousePopupLeave(e) {
        e.preventDefault();
        setIsActivated(false);
    }

    function onMenuItemClick(e) {
        e.preventDefault();
        let item = e.target.dataset.item;

        if (item == "Bookmark") {
            AddBookmarkMutation(postId, postIdInt, () => {
                // console.log("Added a new Bookmark");
            });
            setIsBookmarked(true);
        }

        if (item == "Copy Link") {
            navigator.clipboard.writeText(props.postLink).then(
                function () {
                    console.log("Link copied to clipboard");
                },
                function (err) {
                    console.log("Error copying to clipboard");
                }
            );
        }

        if (item == "Add Note") {
            if (payment_status === "active" || payment_status === "trialing") {
                setIsNoteModalActive(true);
                if (isSmallScreen) {
                    commitLocalUpdate(environment, (store) => {
                        const record = store
                            .getRoot()
                            .getLinkedRecord("settings");
                        record.setValue(true, "isFullSpanNoteModalActivated");
                    });
                }
            } else if (payment_status === "past_due") {
                navigate("/complete-payment");
            } else {
                navigate("/upgrade");
            }
        }

        if (item == "Share") {
            setIsShareModalActive(true);
            if (isSmallScreen) {
                commitLocalUpdate(environment, (store) => {
                    const record = store.getRoot().getLinkedRecord("settings");
                    record.setValue(true, "isFullSpanShareModalActivated");
                });
            }
        }
    }

    return (
        <div>
            <div className={`popup-menu-container`}>
                {isActivated ? (
                    <div
                        onMouseLeave={onMousePopupLeave}
                        className={`popup-menu theme-${theme.secondary} theme-${theme.shadow} popup-menu-${isActivated}`}
                    >
                        <div className={`menu-item`}>
                            <a
                                className={`theme-${theme.paragraph}`}
                                target="_blank"
                                href={props.postLink}
                            >
                                <div id="popup-bookmark-icon">
                                    <SvgWebIcon />
                                </div>

                                <label htmlFor="popup-bookmark-icon">
                                    Open Website
                                </label>
                            </a>
                        </div>

                        <div className={`menu-item`} onClick={onMenuItemClick}>
                            <div id="popup-link-icon">
                                <SvgLinkIcon size={18} />
                            </div>
                            <label
                                className={`theme-${theme.paragraph}`}
                                htmlFor="popup-link-icon"
                                data-item="Copy Link"
                            >
                                Copy Link
                            </label>
                        </div>

                        {/* <div className={`menu-item`} onClick={onMenuItemClick}> */}
                        {/*     <div id="popup-share-icon"> */}
                        {/*         <SvgShareIcon size={18} /> */}
                        {/*     </div> */}
                        {/*     <label */}
                        {/*         className={`theme-${theme.paragraph}`} */}
                        {/*         htmlFor="popup-share-icon" */}
                        {/*         data-item="Share" */}
                        {/*     > */}
                        {/*         Share */}
                        {/*     </label> */}
                        {/* </div> */}

                        <div className={`menu-item`} onClick={onMenuItemClick}>
                            <div id="popup-note-icon">
                                <SvgNoteIcon size={18} />
                            </div>
                            <label
                                className={`theme-${theme.paragraph}`}
                                data-item="Add Note"
                            >
                                Add Note
                            </label>
                        </div>

                        <div className={`menu-item`} onClick={onMenuItemClick}>
                            <div>
                                <SvgBookmarkIcon size={18} />
                            </div>
                            <label
                                className={`theme-${theme.paragraph}`}
                                data-item="Bookmark"
                            >
                                Bookmark
                            </label>
                        </div>
                    </div>
                ) : null}

                {isSmallScreen ? (
                    <div>
                        {isNoteModalActive ? (
                            <div>
                                {isFullSpanNoteModalActivated ? (
                                    <div>
                                        <FullSpanNoteModal
                                            isActivated={true}
                                            postId={postId}
                                        />{" "}
                                    </div>
                                ) : null}
                            </div>
                        ) : null}

                        {isShareModalActive ? (
                            <div>
                                {isFullSpanShareModalActivated ? (
                                    <div>
                                        <FullSpanShareModal
                                            postLink={props.postLink}
                                            postTitle={props.postTitle}
                                            isActivated={true}
                                            user={user}
                                        />
                                    </div>
                                ) : null}
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                ) : (
                    <div>
                        {isNoteModalActive ? (
                            <div>
                                <NoteModal
                                    title="Note"
                                    actionButton="Save"
                                    setIsModalActive={setIsNoteModalActive}
                                    isModalActive={isNoteModalActive}
                                    postId={postId}
                                    isDetailView={false}
                                />
                            </div>
                        ) : null}

                        {isShareModalActive ? (
                            <div>
                                <ShareModal
                                    title="Share"
                                    setIsModalActive={setIsShareModalActive}
                                    isModalActive={isShareModalActive}
                                    postLink={props.postLink}
                                    postTitle={props.postTitle}
                                    user={user}
                                />
                            </div>
                        ) : null}
                    </div>
                )}
            </div>

            <div className="article-menu">
                <BookmarkContainer
                    postId={props.postId}
                    user={user}
                    settings={settings}
                />
                <div onClick={onArticleMenuClick}>
                    <img className="more-button" src={more} />
                </div>
            </div>
        </div>
    );
}

export default PopupMenu;
